import { Tooltip } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CSS from 'csstype';
import React from 'react';

import { Col, Cols, ITProps, Row, spacing, Text, TKey } from '~/src/dash/publicaUI';
import { IListItem } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';

export interface ISelectOption {
  id: number | string;
  label: string;
  isActive?: boolean; // use if there is a needed active column
  createdAt?: string;
  updatedAt?: string;
  sortValue?: string | number;
  tKey?: TKey;
  tProps?: ITProps; // translation properties for the label
  childrenIDs?: number[];
  parentKeyMap?: Record<string, number[] | string[]>; // key is parent selectKey, value is array of parent IDs
  isCustom?: boolean; // true to set flag for custom logic
}

export interface ISelectPreset {
  label: string;
  subset: Set<string | number>;
  tKey?: TKey;
}

export const generateOptionsListAsPromise = (
  options: ISelectOption[],
): Promise<ISelectOption[]> => {
  return new Promise((resolve) => {
    resolve(options);
  });
};

interface IVirtualRowProps {
  displayID?: boolean;
  handleChange: (id: string) => void;
  index: number;
  options: IListItem[];
  // @ts-ignore
  style: Properties<string | 0>;
  isDisabled?: boolean;
  disabledOptionTooltip?: string;
}

const checkboxStyle: CSS.Properties = {
  marginRight: spacing.small,
  color: publicaColors.darkGray,
};

export const VirtualRow = ({
  index,
  style,
  options,
  handleChange,
  displayID = false,
  disabledOptionTooltip,
}: IVirtualRowProps) => {
  const { ID, selected, title, isDisabled } = options[index];
  return (
    <Row
      onClick={() => handleChange(ID)}
      style={{ ...style, cursor: 'pointer', padding: '4px 8px 0px' }}
      className={`virtual-row-${index}`}
    >
      <Cols gap={spacing.small} style={{ alignItems: 'flex-start' }}>
        <Col>
          {selected ? (
            <CheckBoxIcon style={checkboxStyle} />
          ) : (
            <CheckBoxOutlineBlankOutlinedIcon style={checkboxStyle} />
          )}
        </Col>
        {displayID && (
          <Col style={{ minWidth: '40px', paddingTop: '1px' }}>
            <Text small muted bold={selected}>
              {ID}
            </Text>
          </Col>
        )}
        <Col style={{ paddingTop: '1px' }}>
          <Tooltip title={isDisabled && disabledOptionTooltip ? '' : title}>
            <div>
              <Text
                small
                bold={selected}
                style={{
                  width: '320px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {title}
              </Text>
            </div>
          </Tooltip>
        </Col>
      </Cols>
    </Row>
  );
};
